import { style, styleVariants } from "@vanilla-extract/css";
import { breakpoints } from "../../styles";
import { vars } from "../../styles/theme.css";

export const infoIcon = style({
  display: "block",
  margin: "auto",
  width: 10,
  height: 10,
  color: vars.colors.onSurface,
  "@media": {
    [`(min-width: ${breakpoints[2]})`]: {
      width: 16,
      height: 16,
    },
  },
});

export const statusIconVariants = styleVariants({
  0: [
    infoIcon,
    {
      fill: vars.colors.copnr[0].backgroundColor,
      color: vars.colors.copnr[0].color,
    },
  ],
  25: [
    infoIcon,
    {
      fill: vars.colors.copnr[25].backgroundColor,
      color: vars.colors.copnr[25].color,
    },
  ],
  50: [
    infoIcon,
    {
      fill: vars.colors.copnr[50].backgroundColor,
      color: vars.colors.copnr[50].color,
    },
  ],
  75: [
    infoIcon,
    {
      fill: vars.colors.copnr[75].backgroundColor,
      color: vars.colors.copnr[75].color,
    },
  ],
  default: [infoIcon],
});
